import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { UntypedFormBuilder } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { ResponseState } from '../../models/support/response-state';
import { SharedService } from '../../services/other/shared.service';
import { TransactionsSecondService } from '../../services/transaction/transactions-second.service';
import { PaginationComponent } from '../pagination/pagination.component';
import { ToastrService } from 'ngx-toastr';
import { Company } from '../../models/classes/company/company';
import { ClientsLoyaltyPointInfoSearchCriteria } from 'src/app/models/classes/transactions/clients-loyalty-point-info-search-criteria';
import { ClientLoyaltyPointInfoSearchResult, ClientLoyaltyPointLogsSearchResult } from 'src/app/models/search-result/client-loyalty-points-search-result';
import { ClientLoyaltyPointDTO, ClientLoyaltyPointExpirationDTO, ClientLoyaltyPointLogDTO } from 'src/app/models/classes/transactions/client-loyalty-point-DTO';
import { LoyalityPointsDirection } from 'src/app/models/enums/loyality-points-direction';

@Component({
  selector: 'app-modal-client-loyalty-points-info',
  templateUrl: './modal-client-loyalty-points-info.component.html',
  styleUrls: ['./modal-client-loyalty-points-info.component.scss'],
  providers: [DatePipe],
})
export class ModalClientLoyaltyPointsInfoComponent implements OnInit {

  @ViewChild('pagerClientLoyaltyPointLogs', { static: true })
  pagerClientLoyaltyPointLogs: PaginationComponent;

  public ClientLoyaltyPointExpirations: ClientLoyaltyPointExpirationDTO[];
  public ClientLoyaltyPointLogs: ClientLoyaltyPointLogDTO[];

  @Input() ClientLoyaltyPoint: ClientLoyaltyPointDTO;

  public LoadingGetClientLoyaltyPointExpirations: boolean = false;
  public LoadingGetClientLoyaltyPointLogs: boolean = false;

  public freeTextGetGiftCardBranches: string;
  public freeTextGetGiftCardUsingDetails: string;
  public freeTextGetGiftCardOTPCodes: string;
  public Company: Company;

  constructor(
    public activeModal: NgbActiveModal,
    public translate: TranslateService,
    public sharedService: SharedService,
    public _transactionsSecondService: TransactionsSecondService,
    private fb: UntypedFormBuilder,
    public datepipe: DatePipe,
    private ngbModal: NgbModal,
    public toaster: ToastrService
  ) { }

  ngOnInit(): void {
    this.Company = this.sharedService.CurrentCompany;

    this.pagerClientLoyaltyPointLogs.pageSize = 10;
    this.pagerClientLoyaltyPointLogs.ddlPageSize = 10;
    this.pagerClientLoyaltyPointLogs.GlobalPageIndex = 0;

    this.GetClientLoyaltyPointInfo();
    this.GetClientLoyaltyPointLogs();
  }
  public get loyalityPointsDirection(): typeof LoyalityPointsDirection {
    return LoyalityPointsDirection;
  }

  GetClientLoyaltyPointInfo() {
    let clientsLoyaltyPointInfoSearchCriteria =
      new ClientsLoyaltyPointInfoSearchCriteria();
    clientsLoyaltyPointInfoSearchCriteria.ClientId = this.ClientLoyaltyPoint.ClientId;
    this.LoadingGetClientLoyaltyPointExpirations = true;

    this._transactionsSecondService
      .GetClientLoyaltyPointInfo(clientsLoyaltyPointInfoSearchCriteria)
      .subscribe((result: ClientLoyaltyPointInfoSearchResult) => {
        if (result.State == ResponseState.Success) {
          if (result.ClientLoyaltyPointInfo?.ClientLoyaltyPointExpirations) {
            this.ClientLoyaltyPointExpirations = result.ClientLoyaltyPointInfo.ClientLoyaltyPointExpirations;
          } else {
            this.ngbModal.dismissAll();
            this.toaster.error(
              this.translate.instant('Sorry!ErrorHappen!')
            );
          }
        }
        this.LoadingGetClientLoyaltyPointExpirations = false;
      });
  }

  divName;
  printPage() {
    this.divName = 'printClientLoyaltyPointsInfo';
    console.log(this.divName);

    let printContents = document.getElementById(this.divName).innerHTML;
    let originalContents = document.body.innerHTML;

    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
    window.location.reload();
    // this.divName = null;
  }

  GetClientLoyaltyPointLogs() {
    this.LoadingGetClientLoyaltyPointLogs = true;
    var criteria = new ClientsLoyaltyPointInfoSearchCriteria();

    criteria.FreeText = this.freeTextGetGiftCardUsingDetails;
    criteria.ClientId = this.ClientLoyaltyPoint.ClientId;
    criteria.PageSize = this.pagerClientLoyaltyPointLogs.pageSize;
    criteria.PagingEnabled = true;
    criteria.PageNumber = this.pagerClientLoyaltyPointLogs.GlobalPageIndex;

    this._transactionsSecondService
      .GetClientLoyaltyPointLogs(criteria)
      .subscribe((response: ClientLoyaltyPointLogsSearchResult) => {
        this.LoadingGetClientLoyaltyPointLogs = false;
        if (response.State == ResponseState.Success) {
          this.ClientLoyaltyPointLogs =
            response.ClientLoyaltyPointLogs ?? [];
          this.pagerClientLoyaltyPointLogs.EventsCount = response.TotalCount;
          this.pagerClientLoyaltyPointLogs.setPage(
            this.pagerClientLoyaltyPointLogs.GlobalPageIndex,
            false
          );
        }
      });
  }

  ReciveFreeTextGetGiftCardUsingDetails(e) {
    console.log(e);
    this.freeTextGetGiftCardUsingDetails = e;
    this.GetClientLoyaltyPointLogs();
  }


}
